// extracted by mini-css-extract-plugin
export default {"CloseIcon":"R6GUvD8X","Iframe":"TEYqMemS","V2":"uKXAGsd9"};